import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-258">
      <div className="max-w-3xl mx-auto" data-id="element-259">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-260">
          El resultado para vos como docente
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-261">
          Con este pack vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-262">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-263">
            <li className="flex items-start" data-id="element-264">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-265" />
              <span data-id="element-266">Ahorrar horas de preparación</span>
            </li>
            <li className="flex items-start" data-id="element-267">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-268" />
              <span data-id="element-269">Tener todo organizado durante el año</span>
            </li>
            <li className="flex items-start" data-id="element-270">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-271" />
              <span data-id="element-272">Trabajar efemérides de forma clara</span>
            </li>
            <li className="flex items-start" data-id="element-273">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-274" />
              <span data-id="element-275">Destacarte con actividades diferentes</span>
            </li>
            <li className="flex items-start" data-id="element-276">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-277" />
              <span data-id="element-278">Preparar actos escolares con mayor seguridad</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-279">
          <span className="px-2 bg-[#FFFFFF]" data-id="element-280">
            Todo sin perder tiempo buscando material en internet.
          </span>
        </p>
      </div>
    </section>;
}